import * as React from "react";
import Box from "@mui/material/Box";
import {
  FormControl,
  Grid,
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Drawer,
  InputLabel,
  Select,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { get, postJsonData } from "../network/ApiController";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState } from "react";
import { useEffect } from "react";
import { whiteColor } from "../theme/setThemeColor";


let defaultOperator = "operator";
const AddAppVersion = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
 const [platform,setPlatForm]=useState("")
  const [operator, setOperator] = useState("");
  const [operatorVal, setOperatorVal] = useState([]);
  const getOperatorVal = () => {
    get(
      ApiEndpoints.GET_OPERATOR,
      "",
      setRequest,
      (res) => {
        const opArray = res.data.data;
        setOperatorVal(
          opArray &&
            opArray.map((item) => {
              return {
                code: item.code,
                name: item.name,
              };
            })
        );
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };
  useEffect(() => {
    getOperatorVal();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    bgcolor: "background.paper",
    boxShadow: 24,
    fontFamily: "Poppins",
    p: 2,
    height: "max-content",
    overflowY: "scroll",
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = {
      operator: operator,
      version: form.version.value,
      platform: platform,
      message: form.message.value,
    };
    setRequest(true);
    postJsonData(
      ApiEndpoints.ADD_APP_VERSION,
      data,
      setRequest,
      (res) => {
        okSuccessToast("version added successfully");
        handleClose();
        if (refresh) refresh();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
       <Tooltip title=" Add version">
          <Button
            variant="outlined"
            // className="button-transparent"
            className="refresh-icon-risk"
            onClick={handleOpen}
            startIcon={
              <IconButton
                sx={{
                  p: 0,

                  color: whiteColor(),
                }}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            }
            sx={{ py: 0.3 }}
          >
      Add version
          </Button>
        </Tooltip>

      <Drawer
        open={open}
        anchor="right"
        onClose={handleClose}
    
      >
        <Box sx={{width:400}} className="sm_modal">
          <ModalHeader title="Add version" handleClose={handleClose}subtitle="Simplify Your Workflow: Add New version" />
          <Box
            component="form"
            id="addversion"
            validate="true"
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
          
              <Grid item md={12} xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField autoComplete="off" label="version" id="version" size="small" required />
                </FormControl>
              </Grid>

 <Grid item md={12} xs={12}>
  <FormControl sx={{ width: "95%", ml: 1 }} size="small" required>
    <InputLabel id="platform-label">Platform</InputLabel>
    <Select
      labelId="platform-label"
      id="platform"
      value={platform}
      onChange={(e) => setPlatForm(e.target.value)}
    >
      <MenuItem value="android">Android</MenuItem>
      <MenuItem value="web">Web</MenuItem>
    </Select>
  </FormControl>
</Grid>



              <Grid item md={12} xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField autoComplete="off"
                    label="message"
                    id="message"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{mr:"10px"}}>
          <ModalFooter form="addversion" request={request} />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};
export default AddAppVersion;
